import api from '@/services/api';

const getDefaultState = () => {
  return {
    barrePCU: false,
  };
};

const state = getDefaultState();

const mutations = {
  RESET(state) {
    Object.assign(state, getDefaultState());
  },

  SET_BARRE_PCU(state, value) {
    state.barrePCU = value;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
